import { Topbar, CardGridWrapper, Page } from 'components'
import { inject, observer } from 'mobx-react'
import { Course, Package, Program } from 'models'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Pages } from 'routes'
import { AuthStore, RoutingStore } from 'stores'
import { DataType } from 'types'
import { ShowContentTypes } from 'types/filter'
import { MainSidebar } from 'views'


type Content = Course | Program | Package;
export interface ILibraryProps {
  authStore?:    AuthStore,
  routingStore?: RoutingStore,
}

/**
 * Displays a list of all courses and programs the current user has access to.
 *
 * @type Participant, Manager
 */

export const Library = inject('authStore', 'routingStore')(observer((props: ILibraryProps) => {
  const { t } = useTranslation();
  const { authStore, routingStore } = props;

  const [parent, setParent] = React.useState<Content>(null);

  return (
    <Page sidebar={<MainSidebar />} topbar={<Topbar showBackButton={Boolean(parent)} onBack={() => setParent(null)} />}>
      <CardGridWrapper 
        showSorting
        showCompleted
        contentType = {ShowContentTypes.All}
        title       = {parent?.title || t('library')}
        desc        = {parent?.desc || t('library_description')}
        parent      = {parent}
        onCardClick = {(c: Content) => {
          if(c.data_type === DataType.Course)
            routingStore.push(Pages.Course, { id: '' + c.id });
          else setParent(c);
        }}
        defaultContentTypeFilter = {ShowContentTypes.Packages}
      />
    </Page>
  );
}));